// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReferralInfo_stepsContainer__oxd-z {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 472px;
}

.ReferralInfo_stepCard__lB-8l {
  background: #220a3d;
  border: 1px solid #310e58;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ReferralInfo_stepIcon__Y2zAT {
  width: 24px;
  height: 24px;
}

.ReferralInfo_stepTextContainer__GWFHT {
  display: flex;
  flex-direction: column;
}

.ReferralInfo_stepTitle__xtAlY {
  font-family: Inter;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  margin: 0;
}

.ReferralInfo_stepDescription__XlSy2 {
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  margin: 0;
}

@media (max-width: 480px) {
  .ReferralInfo_stepsContainer__oxd-z {
    max-width: 100%;
  }
}

@media (min-width: 481px) and (max-width: 1024px) {
  .ReferralInfo_stepsContainer__oxd-z {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/CheckoutPage/ReferralInfo/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".stepsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: 472px;\n}\n\n.stepCard {\n  background: #220a3d;\n  border: 1px solid #310e58;\n  border-radius: 16px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.stepIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.stepTextContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.stepTitle {\n  font-family: Inter;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ffffff;\n  margin: 0;\n}\n\n.stepDescription {\n  font-family: Inter;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ffffff;\n  margin: 0;\n}\n\n@media (max-width: 480px) {\n  .stepsContainer {\n    max-width: 100%;\n  }\n}\n\n@media (min-width: 481px) and (max-width: 1024px) {\n  .stepsContainer {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepsContainer": `ReferralInfo_stepsContainer__oxd-z`,
	"stepCard": `ReferralInfo_stepCard__lB-8l`,
	"stepIcon": `ReferralInfo_stepIcon__Y2zAT`,
	"stepTextContainer": `ReferralInfo_stepTextContainer__GWFHT`,
	"stepTitle": `ReferralInfo_stepTitle__xtAlY`,
	"stepDescription": `ReferralInfo_stepDescription__XlSy2`
};
export default ___CSS_LOADER_EXPORT___;
